import React from "react";
import PageHero from "../components/PageHero";
import Services from "../components/Services";
import HowWeWork from "../components/HowWeWork";
import WhyProspera from "../components/WhyProspera";
import CTABanner from "../components/CTABanner";
import { IMAGES } from "../config/siteConfig";

export default function ServicesPage() {
  return (
    <>
      <PageHero
        label="Services"
        title="Workforce solutions built around"
        highlight="your business."
        subtitle="From permanent recruitment to executive search and offshore staffing, we deliver flexible hiring solutions matched to how your organization grows."
        image={IMAGES.employers}
      />
      <Services />
      <HowWeWork />
      <WhyProspera />
      <CTABanner heading="Need the right people, fast?" highlight="We can help." />
    </>
  );
}
